var _polygon, _polygon2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#76BDF6"
    },
    points: "368.814,0 143.186,0 143.186,199.593 82.441,199.593 256,303.729 429.559,199.593  368.814,199.593 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3689C9"
    },
    d: "M472.949,112.814H368.814v34.712h104.136v225.627H39.051V147.525h104.136v-34.712H39.051 c-19.17,0-34.712,15.542-34.712,34.712v242.983c0,19.17,15.542,34.712,34.712,34.712h433.898c19.17,0,34.712-15.542,34.712-34.712 V147.525C507.661,128.356,492.119,112.814,472.949,112.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDDBA"
    },
    d: "M39.051,373.153h433.898V147.525H368.814v52.068h60.746L256,303.729L82.441,199.593h60.746v-52.068 H39.051V373.153z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3689C9"
    },
    d: "M4.339,477.288C4.339,506.047,27.648,512,56.407,512h399.186c28.759,0,52.068-5.953,52.068-34.712 H4.339z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3689C9"
    },
    points: "169.22,477.288 342.78,477.288 316.746,425.22 195.254,425.22  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDDBA"
    },
    d: "M308.068,86.78l-43.39-26.034C256,86.78,203.932,86.78,203.932,86.78 c0,28.759,33.662,52.068,52.068,52.068S308.068,115.538,308.068,86.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#854F09"
    },
    d: "M264.678,60.746l43.39,26.034c0-28.759-8.678-60.746-52.068-60.746s-52.068,31.987-52.068,60.746 C203.932,86.78,256,86.78,264.678,60.746z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3689C9"
    },
    d: "M186.576,208.271v-34.712c0-19.17,15.542-34.712,34.712-34.712h69.424 c19.17,0,34.712,15.542,34.712,34.712v34.712H186.576z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3689C9"
    },
    points: "442.576,316.746 420.881,316.746 420.881,295.051 412.203,295.051 412.203,316.746  390.508,316.746 390.508,325.424 412.203,325.424 412.203,347.119 420.881,347.119 420.881,325.424 442.576,325.424  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.14
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "316.746,425.22 195.254,425.22 190.915,433.898 195.254,433.898 316.746,433.898 321.085,433.898  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.14
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "256,303.729 111.364,216.949 82.441,216.949 256,321.085 429.559,216.949 400.636,216.949  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientLogoLogin);
export default __webpack_public_path__ + "static/media/patient-logo-login.fd8d476a6fb451768f0b6ac43a58cc75.svg";
export { ForwardRef as ReactComponent };